var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "registration" }, [
    !_vm.registration
      ? _c("div", { staticClass: "text-center mb-5" }, [
          !_vm.org ? _c("h2", [_vm._v("Join CAT-UXO")]) : _vm._e(),
          _vm._v(" "),
          _c("h1", [_vm._v("Create your account")]),
          _vm._v(" "),
          _vm.org
            ? _c("h2", [
                _vm._v(
                  "You've been invited to join " +
                    _vm._s(_vm.org.name) +
                    " on CAT-UXO"
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.registration !== true
      ? _c(
          "section",
          { staticClass: "column is-8-desktop px-0 px-sm-2 mx-auto" },
          [
            _c(
              "form",
              {
                staticClass:
                  "form form-register  bg-white p-5 shadow rounded-lg",
                attrs: { method: "POST" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "account-details d-flex flex-column justify-content-center"
                  },
                  [
                    _c("div", { staticClass: "columns" }, [
                      _c("div", { staticClass: "column is-half" }, [
                        _c(
                          "div",
                          {
                            staticClass: "field mb-4",
                            class: { "has-error": _vm.$v.form.fullName.$error }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "label mb-1",
                                attrs: { for: "fullName" }
                              },
                              [_vm._v("Full Name*")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.$v.form.fullName.$model,
                                    expression: "$v.form.fullName.$model",
                                    modifiers: { trim: true }
                                  }
                                ],
                                staticClass: "input",
                                attrs: {
                                  id: "fullName",
                                  name: "full_name",
                                  type: "text"
                                },
                                domProps: {
                                  value: _vm.$v.form.fullName.$model
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.$v.form.fullName,
                                      "$model",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function($event) {
                                    return _vm.$forceUpdate()
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.$v.$dirty && _vm.$v.form.fullName.$error
                              ? _c("div", { staticClass: "error" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.getErrorMessage(
                                          _vm.$v.form.fullName
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "column is-half" }, [
                        _c(
                          "div",
                          {
                            staticClass: "field mb-4",
                            class: { "has-error": _vm.$v.form.email.$error }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "label mb-1",
                                attrs: { for: "email" }
                              },
                              [_vm._v("Email Address*")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.$v.form.email.$model,
                                    expression: "$v.form.email.$model",
                                    modifiers: { trim: true }
                                  }
                                ],
                                staticClass: "input",
                                attrs: {
                                  id: "email",
                                  name: "email",
                                  type: "email"
                                },
                                domProps: { value: _vm.$v.form.email.$model },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.$v.form.email,
                                      "$model",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function($event) {
                                    return _vm.$forceUpdate()
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.$v.$dirty && _vm.$v.form.email.$error
                              ? _c("div", { staticClass: "error" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.getErrorMessage(_vm.$v.form.email)
                                      ) +
                                      "\n                            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    !_vm.org
                      ? [
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column is-half" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "field mb-4",
                                  class: {
                                    "has-error": _vm.$v.form.country.$error
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "label mb-1",
                                      attrs: { for: "nationality" }
                                    },
                                    [_vm._v("Nationality*")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "control" }, [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.trim",
                                            value: _vm.$v.form.country.$model,
                                            expression:
                                              "$v.form.country.$model",
                                            modifiers: { trim: true }
                                          }
                                        ],
                                        staticClass: "select",
                                        attrs: {
                                          id: "nationality",
                                          name: "nationality"
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.$v.form.country,
                                              "$model",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "null",
                                              selected: ""
                                            }
                                          },
                                          [_vm._v("Select your nationality")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.countries, function(
                                          country
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              domProps: { value: country.code }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(country.name) +
                                                  "\n                                        "
                                              )
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ])
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column is-full" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "field mb-4",
                                  class: {
                                    "has-error": _vm.$v.form.trainedAt.$error
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "label mb-1",
                                      attrs: { for: "trainedAt" }
                                    },
                                    [
                                      _vm._v(
                                        "Where did you attend your EOD\n                                    training?*"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "control" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.$v.form.trainedAt.$model,
                                          expression:
                                            "$v.form.trainedAt.$model",
                                          modifiers: { trim: true }
                                        }
                                      ],
                                      staticClass: "input",
                                      attrs: {
                                        id: "trainedAt",
                                        name: "trained_at",
                                        type: "text"
                                      },
                                      domProps: {
                                        value: _vm.$v.form.trainedAt.$model
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.$v.form.trainedAt,
                                            "$model",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.$forceUpdate()
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _vm.$v.$dirty && _vm.$v.form.trainedAt.$error
                                    ? _c("div", { staticClass: "error" }, [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.getErrorMessage(
                                                _vm.$v.form.trainedAt
                                              )
                                            ) +
                                            "\n                                "
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column is-full" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "field mb-4",
                                  class: {
                                    "has-error": _vm.$v.form.currentWork.$error
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "label mb-1",
                                      attrs: { for: "currentWork" }
                                    },
                                    [
                                      _vm._v(
                                        "Where do you work at the\n                                    moment?*"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "control" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.$v.form.currentWork.$model,
                                          expression:
                                            "$v.form.currentWork.$model",
                                          modifiers: { trim: true }
                                        }
                                      ],
                                      staticClass: "input",
                                      attrs: {
                                        id: "currentWork",
                                        name: "current_work",
                                        type: "text"
                                      },
                                      domProps: {
                                        value: _vm.$v.form.currentWork.$model
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.$v.form.currentWork,
                                            "$model",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.$forceUpdate()
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _vm.$v.$dirty &&
                                  _vm.$v.form.currentWork.$error
                                    ? _c("div", { staticClass: "error" }, [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.getErrorMessage(
                                                _vm.$v.form.currentWork
                                              )
                                            ) +
                                            "\n                                "
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column is-full" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "field mb-4",
                                  class: {
                                    "has-error": _vm.$v.form.explanation.$error
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "label mb-1",
                                      attrs: { for: "explanation" }
                                    },
                                    [
                                      _vm._v(
                                        "Give a brief explanation of why you wish\n                                    to\n                                    become a member of CAT-UXO*"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "control" }, [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.$v.form.explanation.$model,
                                          expression:
                                            "$v.form.explanation.$model",
                                          modifiers: { trim: true }
                                        }
                                      ],
                                      staticClass: "textarea",
                                      attrs: {
                                        id: "explanation",
                                        name: "explanation"
                                      },
                                      domProps: {
                                        value: _vm.$v.form.explanation.$model
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.$v.form.explanation,
                                            "$model",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.$forceUpdate()
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _vm.$v.$dirty &&
                                  _vm.$v.form.explanation.$error
                                    ? _c("div", { staticClass: "error" }, [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.getErrorMessage(
                                                _vm.$v.form.explanation
                                              )
                                            ) +
                                            "\n                                "
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column is-full" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "field mb-4",
                                  class: {
                                    "has-error": _vm.$v.form.purpose.$error
                                  }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "label mb-1",
                                      attrs: { for: "purpose" }
                                    },
                                    [
                                      _vm._v(
                                        "What purpose do you wish to use CAT-UXO\n                                    for?*"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "control" }, [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.$v.form.purpose.$model,
                                          expression: "$v.form.purpose.$model",
                                          modifiers: { trim: true }
                                        }
                                      ],
                                      staticClass: "textarea",
                                      attrs: { id: "purpose", name: "purpose" },
                                      domProps: {
                                        value: _vm.$v.form.purpose.$model
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.$v.form.purpose,
                                            "$model",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.$forceUpdate()
                                        }
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _vm.$v.$dirty && _vm.$v.form.purpose.$error
                                    ? _c("div", { staticClass: "error" }, [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.getErrorMessage(
                                                _vm.$v.form.purpose
                                              )
                                            ) +
                                            "\n                                "
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "columns" }, [
                      _c("div", { staticClass: "column is-half" }, [
                        _c(
                          "div",
                          {
                            staticClass: "field mb-5",
                            class: { "has-error": _vm.$v.form.password.$error }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "label mb-1",
                                attrs: { for: "password" }
                              },
                              [_vm._v("Password*")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.$v.form.password.$model,
                                    expression: "$v.form.password.$model",
                                    modifiers: { trim: true }
                                  }
                                ],
                                staticClass: "input",
                                attrs: {
                                  id: "password",
                                  name: "password",
                                  type: "password"
                                },
                                domProps: {
                                  value: _vm.$v.form.password.$model
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.$v.form.password,
                                      "$model",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function($event) {
                                    return _vm.$forceUpdate()
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.$v.$dirty && _vm.$v.form.password.$error
                              ? _c("div", { staticClass: "error" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.getErrorMessage(
                                          _vm.$v.form.password
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "column is-half" }, [
                        _c(
                          "div",
                          {
                            staticClass: "field mb-5",
                            class: {
                              "has-error":
                                _vm.$v.form.passwordConfirmation.$error
                            }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "label mb-1",
                                attrs: { for: "passwordConfirmation" }
                              },
                              [_vm._v("Confirm Password*")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value:
                                      _vm.$v.form.passwordConfirmation.$model,
                                    expression:
                                      "$v.form.passwordConfirmation.$model",
                                    modifiers: { trim: true }
                                  }
                                ],
                                staticClass: "input",
                                attrs: {
                                  id: "passwordConfirmation",
                                  name: "password_confirmation",
                                  type: "password"
                                },
                                domProps: {
                                  value: _vm.$v.form.passwordConfirmation.$model
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.$v.form.passwordConfirmation,
                                      "$model",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function($event) {
                                    return _vm.$forceUpdate()
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.$v.$dirty &&
                            _vm.$v.form.passwordConfirmation.$error
                              ? _c("div", { staticClass: "error" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.getErrorMessage(
                                          _vm.$v.form.passwordConfirmation
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "columns" }, [
                      _c("div", { staticClass: "column is-full" }, [
                        _c(
                          "div",
                          {
                            staticClass: "field mb-3",
                            class: { "has-error": _vm.$v.form.toc.$error }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "position-relative d-flex align-items-center"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: _vm.$v.form.toc.$model,
                                      expression: "$v.form.toc.$model",
                                      modifiers: { trim: true }
                                    }
                                  ],
                                  staticClass: "input-checkbox",
                                  attrs: { name: "toc", type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.$v.form.toc.$model
                                    )
                                      ? _vm._i(_vm.$v.form.toc.$model, null) >
                                        -1
                                      : _vm.$v.form.toc.$model
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.$v.form.toc.$model,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.$v.form.toc,
                                              "$model",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.$v.form.toc,
                                              "$model",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.$v.form.toc, "$model", $$c)
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "check-toggle" }),
                                _vm._v(" "),
                                _vm._m(0)
                              ]
                            ),
                            _vm._v(" "),
                            _vm.$v.$dirty && _vm.$v.form.toc.$error
                              ? _c("div", { staticClass: "error" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.getErrorMessage(_vm.$v.form.toc)
                                      ) +
                                      "\n                            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "field mx-auto mb-3" },
                      [
                        !_vm.loading
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-form",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.createAccount($event)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        Create your account\n                    "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.loading
                          ? _c("pulse-loader", {
                              attrs: {
                                loading: true,
                                color: "#E57722",
                                size: "20px"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.errors
                  ? _c(
                      "div",
                      { staticClass: "errors mt-4" },
                      [
                        _vm._l(_vm.errors, function(field) {
                          return _vm._l(field, function(error) {
                            return _c("div", { staticClass: "error" }, [
                              _vm._v(_vm._s(error))
                            ])
                          })
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.registration === true
      ? _c("div", { staticClass: "notification mx-auto" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "column is-full mb-1" }, [
            _c("h1", { staticClass: "w-872 mx-auto text-center" }, [
              _vm._v(
                "You’ve successfully created your " +
                  _vm._s(_vm.user.plan) +
                  " account!"
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column is-full mb-4" }, [
            _c("p", { staticClass: "w-648 t-black mx-auto text-center " }, [
              _vm._v(
                "You’ve successfully created your " +
                  _vm._s(_vm.user.plan) +
                  " account.\n                If you want to edit your account details then head over to your user profile after logging in."
              )
            ])
          ]),
          _vm._v(" "),
          _vm._m(2)
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "toc ml-1 font-weight-light" }, [
      _vm._v("Accept that you have read our\n                                "),
      _c("a", { staticClass: "btn-link", attrs: { href: "/privacy-policy" } }, [
        _vm._v("Privacy Policy")
      ]),
      _vm._v(" and "),
      _c(
        "a",
        {
          staticClass: "btn-link",
          attrs: { href: "/terms-conditions", target: "_blank" }
        },
        [_vm._v("Terms & Conditions")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-1 mx-auto text-center mb-1" }, [
      _c("img", {
        staticClass: "icon__email-sent",
        attrs: { src: "/img/icons/email-sent.svg", alt: "Email icon" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "column d-flex justify-content-center is-4 mx-auto" },
      [
        _c("a", { staticClass: "btn", attrs: { href: "/login" } }, [
          _vm._v("Login")
        ])
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c2935ba4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2935ba4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/forms/Register.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c2935ba4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/forms/Register.vue
// module chunks = 0 1